import React,{
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./CurrentStreak.css";

import{

    Flame,

    CalendarDays

} from "lucide-react";

const CurrentStreak=()=>{

    const email=
    localStorage.getItem(
        "user_email"
    );

    const[data,setData]=
    useState(null);

    useEffect(()=>{

        loadStreak();

    },[]);

    const loadStreak=async()=>{

        try{

            const res=
            await axios.get(

                `/api/ignite/profile/${email}`

            );

            setData(

                res.data.stats

            );

        }

        catch(err){

            console.error(err);

        }

    };

    if(!data){

        return(

            <div className="current-streak-card">

                Loading...

            </div>

        );

    }

    const days=[

        "Mon",

        "Tue",

        "Wed",

        "Thu",

        "Fri",

        "Sat",

        "Sun"

    ];

    return(

        <div className="current-streak-card">

            <div className="streak-header">

                <div>

                    <h2>

                        Current Streak

                    </h2>

                    <p>

                        Stay consistent every day.

                    </p>

                </div>

                <Flame size={34}/>

            </div>

            <div className="streak-count">

                {data.currentStreak}

                <span>

                    Days

                </span>

            </div>

            <div className="week-progress">

                {

                    days.map(

                        (day,index)=>(

                            <div

                                key={index}

                                className={

                                    index<

                                    Math.min(

                                        data.currentStreak,

                                        7

                                    )

                                    ?

                                    "week-day active"

                                    :

                                    "week-day"

                                }

                            >

                                {day}

                            </div>

                        )

                    )

                }

            </div>

            <div className="streak-footer">

                <CalendarDays size={18}/>

                <span>

                    Longest Streak

                </span>

                <strong>

                    {

                        data.longestStreak

                    }

                    Days

                </strong>

            </div>

        </div>

    );

};

export default CurrentStreak;